import { hasHeader, type Header } from './header';

/** 编辑器私有属性前缀 —— 导出前一律剥除（锁定状态等编辑器状态不许落进文件） */
export const EDITOR_ATTR_PREFIX = 'data-editor-';

function stripEditorAttrs(el: Element): void {
  for (const attr of Array.from(el.attributes)) {
    if (attr.name.startsWith(EDITOR_ATTR_PREFIX)) el.removeAttribute(attr.name);
  }
  for (const child of Array.from(el.children)) stripEditorAttrs(child);
}

export interface SerializeOptions {
  /** 默认 true：删掉 data-editor-* */
  stripEditorAttrs?: boolean;
}

/**
 * DOM → SVG 文本。在**克隆体**上做清洗，绝不污染屏幕上的活文档。
 * 头部信息（XML 声明 / DOCTYPE / 根外注释）按原文补回。
 */
export function serializeSvg(svg: Element, header: Header, opts: SerializeOptions = {}): string {
  const clone = svg.cloneNode(true) as Element;
  if (opts.stripEditorAttrs !== false) stripEditorAttrs(clone);
  const body = new XMLSerializer().serializeToString(clone);
  if (!hasHeader(header)) return body;
  return [header.xmlDecl, header.doctype, ...header.leadingComments, body]
    .filter((s): s is string => Boolean(s))
    .join('\n');
}
